var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"badge-component"}},[_c('b-badge',{attrs:{"variant":"success"}},[_c('span',[_vm._v(_vm._s(_vm.params.data.Sales_threshold + " -> " + _vm.params.data.Free_Sales_Qty))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }